export const tabsFinalizeds = async ({ isClient, projectId }) => {
  const listOfTabs = [
    {
      url: `/${
        isClient ? "cliente" : "parceiro"
      }/projetos/v2/${projectId}/in-progress/review`,
      label: "Review",
      key: "review",
    },
    {
      url: `/${
        isClient ? "cliente" : "parceiro"
      }/projetos/v2/${projectId}/in-progress/files`,
      label: "Files",
      key: "files",
    },
    {
      url: `/${
        isClient ? "cliente" : "parceiro"
      }/projetos/v2/${projectId}/in-progress/briefing`,
      label: "Briefing",
      key: "briefing",
    },
    isClient
      ? {
          url: `/cliente/projetos/v2/${projectId}/in-progress/po`,
          label: "SPA",
          key: "po",
        }
      : null,
    {
      url: `/${
        isClient ? "cliente" : "parceiro"
      }/projetos/v2/${projectId}/in-progress/extras`,
      label: "Extras",
      key: "extras",
    },
    {
      url: `/${
        isClient ? "cliente" : "parceiro"
      }/projetos/v2/${projectId}/in-progress/finalize`,
      label: "Finalize",
      key: "finalize",
    },
  ];

  return listOfTabs.filter((item) => item !== null && typeof item === "object");
};
